export default "__VITE_ASSET__Bw5jJYsZ__"